export var version = "strings/5.0.9";